// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3WXtw","signatureButtonsRight":"ModalSign_signatureButtonsRight__1cKR6"};